import type { JsonReadOptions } from '@bufbuild/protobuf';

const FROM_JSON_CONFIG: Partial<JsonReadOptions> = {
    ignoreUnknownFields: true,
};

export default FROM_JSON_CONFIG;
